import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

export function Profile({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 20px 34px;display:flex;flex-direction:column")}>
      <button onClick={v.mTabConnect} style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);border:none;background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center;margin-bottom:12px")}>
        <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat")} />
      </button>
      <div style={sx("display:flex;align-items:center;gap:14px;margin-bottom:20px")}>
        <span style={sx("width:52px;height:52px;flex:none;border-radius:var(--radius-full);background:var(--bg-accent);color:#fff;display:flex;align-items:center;justify-content:center;font-size:var(--fs-lg);font-weight:var(--fw-medium)")}>
          M
        </span>
        <span style={sx("display:flex;flex-direction:column;gap:2px")}>
          <span style={sx("font-size:var(--fs-xl);font-weight:var(--fw-bold)")}>
            Michael Corleone
          </span>
          <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
            michael@corleone.com
          </span>
        </span>
      </div>
      <div style={sx("display:flex;flex-direction:column;gap:8px")}>
        {v.hasGroup ? (
          <>
            <Hov as="button" onClick={v.tabGroup} style={sx("text-align:left;padding:14px 16px;border-radius:var(--radius-md);border:1px solid var(--border-secondary);background:var(--bg-secondary);color:var(--text-primary);font-family:inherit;cursor:pointer;display:flex;align-items:center;gap:12px")} hoverStyle={sx("background:var(--bg-tertiary)")}>
              <span style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);background:var(--bg-tertiary);display:flex;align-items:center;justify-content:center")}>
                <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/refer.svg) center/contain no-repeat;mask:url(/assets/icons/refer.svg) center/contain no-repeat")} />
              </span>
              <span style={sx("flex:1;display:flex;flex-direction:column;gap:2px;min-width:0")}>
                <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
                  Group
                </span>
                <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
                  {v.profileGroupSub}
                </span>
              </span>
              <span style={sx("width:16px;height:16px;flex:none;opacity:.5;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat")} />
            </Hov>
          </>
        ) : null}
        <Hov as="button" onClick={v.mOpenSub} style={sx("text-align:left;padding:14px 16px;border-radius:var(--radius-md);border:1px solid var(--border-secondary);background:var(--bg-secondary);color:var(--text-primary);font-family:inherit;cursor:pointer;display:flex;align-items:center;gap:12px")} hoverStyle={sx("background:var(--bg-tertiary)")}>
          <span style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);background:var(--bg-tertiary);display:flex;align-items:center;justify-content:center")}>
            <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/settings.svg) center/contain no-repeat;mask:url(/assets/icons/settings.svg) center/contain no-repeat")} />
          </span>
          <span style={sx("flex:1;display:flex;flex-direction:column;gap:2px;min-width:0")}>
            <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
              Subscription
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              Complete · renews 28 Aug
            </span>
          </span>
          <span style={sx("width:16px;height:16px;flex:none;opacity:.5;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat")} />
        </Hov>
      </div>
    </div>
  )
}
